import React, { useEffect } from 'react';
import { Box, useTheme, useMediaQuery } from '@material-ui/core';
import { Link, useRouteMatch } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import Logo from '../Logo';
import MainMenu from '../MainMenu';
// import NotificationsMenu from './NotificationsMenu';
import ProfileMenu from './ProfileMenu';
import HelpMenu from './HelpMenu';
import useStyles from './styles';
import Actions from '../../store/ducks/userProfile';
import WelcomeModal from '../WelcomeModal';
import { updateLastAccess } from '../../services/userProfile';

const ToolBar = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const isCoursePage = useRouteMatch('/course/:course/:lesson');
  const isAppointmentsPage = useRouteMatch('/appointments');

  const dispatch = useDispatch();

  const {
    auth: { isAuthenticated },
    userProfile,
  } = useSelector(state => state);

  useEffect(() => {
    if (isAuthenticated && !userProfile.name) {
      dispatch(Actions.getUserProfile());
    }
  }, [dispatch, isAuthenticated, userProfile.email, userProfile.name]);

  useEffect(() => {
    if (isAuthenticated) {
      updateLastAccess();
    }
  }, [isAuthenticated]);

  return isSmallScreen && (isCoursePage || isAppointmentsPage) ? null : (
    <Box className={`${classes.container} app-toolbar`}>
      <WelcomeModal />
      <MainMenu />
      <Link className="logo-toolbar" to="/">
        <Logo />
      </Link>
      <HelpMenu />
      {/* <NotificationsMenu /> */}
      <ProfileMenu />
    </Box>
  );
};

export default ToolBar;
